<template>
    <transition name="smooth">
        <div class="dashboard-notifications">
            <div class="notifications-header">
                <div class="row">
                    <div class="col-md-6">
                        <div class="title">Notifications</div>
                    </div>
                    <div class="col-md-6">
                        <div class="notifications-actions">
                            <a  v-if="notifications.length != 0" href="#" @click.prevent="dismissNotifications()" class="dismiss-notifications">Dismiss All</a>
                            <a @click.prevent="$parent.toggleNotifications()" href="#" class="close-notifications"><i class="fa fa-times"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="notification-item-listing">
                <transition name="fade">
                    <div class="row"  v-if="notifications.length == 0">
                        <div class="col-12">
                            <div class="no-notifications-icon"><i class="fas fa-thumbs-up"></i></div>
                            <div class="no-notifications-title">Awesome, you're all caught up!</div>
                        </div>
                    </div>
                    <div v-else>''
                        <transition-group name="fadeSlide" tag="div" class="row">
                            <div class=" col-md-4" v-for="notificationItem in notifications" :key="notificationItem.id">
                                <div class="notification-item" :class="notificationItem.type">
                                    <a target="_blank" v-if="notificationItem.type != 'video'" :href="notificationItem.link"  class="db notification-item-heading clearfix">
                                        <span class="db title">{{notificationItem.title}}</span>
                                        <span class="db icon"></span>
                                    </a>
                                    <a v-else data-toggle="modal" href='#videoModal'  @click.prevent="loadVideoModal(notificationItem)" class="db notification-item-heading clearfix">
                                        <span class="db title">{{notificationItem.title}}</span>
                                        <span class="db icon"></span>
                                    </a>
                                    <div class="notification-item-body">
                                        <a target="_blank" v-if="notificationItem.type != 'video'" :href="notificationItem.link" class="db copy">{{truncateString(notificationItem.copy, 147)}}</a>
                                        <a v-else data-toggle="modal" href='#videoModal'  @click.prevent="loadVideoModal(notificationItem)"  class="db copy">{{truncateString(notificationItem.copy, 147)}}</a>
                                        <div class="notification-item-actions clearfix">
                                            <a target="_blank" v-if="notificationItem.type != 'video'" :href="notificationItem.link" class="read-more">Read More</a>
                                            <a @click.prevent="loadVideoModal(notificationItem)" v-else data-toggle="modal" href='#videoModal' class="read-more">Watch Now</a>
                                            <a href="#" @click.prevent="dismissSingleNotification(notificationItem)"  class="dismiss-individual">Dismiss</a>
                                        </div>
                                    </div>
                                    <div class="video-bg"  v-if="notificationItem.type == 'video'" :class="{'no-thumbnail': notificationItem.thumbnail == null}">
                                        <img v-if="notificationItem.thumbnail !== null" :src="notificationItem.thumbnail" alt="" class="video-thumb">
                                        <img v-else :src="'/images/bg-dashboard.png'" alt="" class="video-thumb">
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </transition>
            </div>
        </div>
    </transition>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'

    Vue.use(VueEvents)

    export default {
        name: 'dashboard-notifications',
        props: ['notifications'],
        data() {
            return {
                defaultVideoBg: base_url + '/hi',
            }
        },
        methods: {
            dismissNotifications: function(){
                this.$emit("dismissAll");
            },
            dismissSingleNotification: function(notificationItem){
                this.$emit("dismissSingle", notificationItem);
            },
            loadVideoModal: function(notification){
                this.$parent.videoModal = notification;
                this.$parent.$refs.videoModal.loadPlayer(notification);
            },
            truncateString: function(string, strLength) {
                let strippedString = string.replace(/(<([^>]+)>)/ig,"");
                return (strippedString.length > strLength) ? strippedString.substr(0, strLength-1) + '...' : strippedString;
            }
        },
    };
</script>

<style scoped="" lang="scss">
    .smooth-enter-active, .smooth-leave-active {
      transition:all .5s linear;
    }
    .smooth-enter, .smooth-leave-to {
      max-height: 0 !important;
      opacity: 0;
    }

    .fadeSlide-enter-active, .fadeSlide-leave-active {
      transition: all .5s linear;
    }
    .fadeSlide-enter, .fadeSlide-leave-to {
      opacity: 0;
      max-width: 1%;
      .copy, .notification-item-actions{
        opacity:0;
      }
    }
    .dashboard-notifications{
        padding:0px 30px;
        max-height: 510px;
        overflow: hidden;
        margin-left: -30px;
        margin-right: -30px;
        margin-bottom:30px;
        background: #FFFFFF;
        box-shadow: inset 0 0 3px 1px rgba(0,0,0,0.10);
    }
    .notifications-header{
        padding:9px 0px;
        min-height:50px;
        border-bottom: 1px solid #F1F2F2;
        .title{
            margin-top: 4px;
            font-size: 16px;
            color: #1F2529;
            text-align: left;
        }
        .notifications-actions{
            text-align: right;
            a{
                font-size: 12px;
                color: #3F759E;
            }
            .dismiss-notifications{
                position: relative;
                top:-2px;
                margin-right:15px;
                font-size: 14px;
                color: #ab5755;
            }
            .close-notifications{
                font-size:20px;
            }
        }
    }
    .notification-item-listing{
        padding: 30px 0 0 0;
        max-height: 456px;
        overflow-y:scroll;
        overflow-x: hidden;
        position: relative;
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: rgba(0,0,0,0);
            position: absolute;
            top: 0px;
            bottom: 0px;
            right: -15px;
        }
        &::-webkit-scrollbar-thumb {
            background: #25628F;
            border-radius:2px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #25628F;
        }
        .notification-item{
            overflow:hidden;
            position: relative;
            margin-bottom:30px;
            padding:0 20px;
            background: #FFFFFF;
            border: 1px solid #DEE0E1;
            border-radius: 12px;
            max-height: 183px;
            .notification-item-heading{
                z-index:2;
                border-bottom:1px solid #F1F2F2;
                padding-top:15px;
                padding-bottom:15px;
                position: relative;
                .title{
                    float: left;
                    font-size: 18px;
                    color: #848484;
                    text-align: left;
                    min-width: 300px;
                }
                .icon{
                    position: absolute;
                    right: 0px;
                    top:15px;
                    float: right;
                    &:after{
                        content:"";
                        color:#A8A8A8;
                        font-size:20px;
                        font-weight: 800;
                        font-family:"Font Awesome 5 Free";
                    }
                }
            }
            .notification-item-body{
                position: relative;
                z-index:2;
                .copy{
                    padding-top:20px;
                    font-size: 13px;
                    color: #5E6468;
                    margin-bottom:10px;
                }
                .notification-item-actions{
                    padding-bottom:15px;
                    .read-more{
                        float: left;
                        font-size: 14px;
                        color: #25628F;
                    }
                    .dismiss-individual{
                        float: right;
                        font-size: 14px;
                        color: #AB5755;
                    }
                }
            }
            .video-bg{
                background-color: #000;
                position: absolute;
                z-index:1;
                top:0;
                bottom:0;
                left:0;
                right:0;
                min-width: 380px;
                .video-thumb{
                    opacity:0.5;
                    width:100%;
                }
                &.no-thumbnail{
                    background-color: #6a8b9e;
                    min-width: 430px;
                }
            }
            &.message{
                .icon:after{
                    content:"\f4ad";
                }
            }
            &.video{
                .icon:after{
                    content:"\f008";
                    color:#fff;
                }
                .notification-item-heading{
                    border-color:#fff;
                }
                .notification-item-body, .copy, .read-more, .dismiss-individual, .title{
                    color:#fff !important;
                }
            }
            &.announcment{
                .icon:after{
                    content:"\f658";
                }
            }
            &.education{
                .icon:after{
                    content:"\f549";
                }
            }
        }
    }
    .no-notifications-icon{
        text-align: center;
        margin-top: 0px;
        font-size:50px;
        color: #c3c3c3;
    }
    .no-notifications-title{
        font-size: 16px;
        color: #7d7d7d;
        text-align: center;
        margin-top: 0px;
        margin-bottom: 60px;
    }
</style>
